<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import IconSearch from "@js/components/Icons/IconSearch.vue";

export default {
    name: "CatalogSearchNotFound",
    components: {IconSearch},
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
}
</script>

<template>
    <div class="flex flex-col items-center justify-center w-full bg-white p-5 border border-gray-200 shadow rounded-xl">
        <div class="flex items-center justify-center border border-gray-200 rounded-full p-4 md:p-5 mb-5">
            <IconSearch class="w-5 md:w-6 h-5 md:h-6 text-gray-800"/>
        </div>
        <div class="text-xl md:text-2xl font-bold text-gray-800 text-center mb-2">
            Ничего не найдено
        </div>
        <div class="text-sm md:text-base font-bold text-gray-800 text-center">
            Попробуйте изменить параметры фильтра или попробуйте
        </div>
        <div @click="catalogStore.resetFilter"
             class="text-sm md:text-base font-bold text-gray-800 text-center underline cursor-pointer hover:text-indigo-600 transition">
            Сбросить фильтр
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
